//swiper
import Swiper from 'swiper/bundle'

document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.swiper-jumbotron', {
    slidesPerView: 'auto',
  })

  new Swiper('.swiper-team', {
    slidesPerView: 'auto',
    spaceBetween: 8,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 16,
      },
    },
  })

  new Swiper('.swiper.other-case__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 8,
    pagination: {
      el: '.other-case__swiper-pagination',
    },
    slidesPerView: 1,
    autoHeight: true,
    breakpoints: {
      1024: {
        spaceBetween: 16,
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
    },
  })

  new Swiper('[data-slider]', {
    //slidesPerView: 'auto',
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    slidesPerView: 1,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
  })

  new Swiper('.slider-case', {
    //slidesPerView: 'auto',
    spaceBetween: 40,
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    slidesPerView: 1,
    breakpoints: {
      1280: {
        spaceBetween: 16,
      },
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
  })

  new Swiper('.slider-case-2', {
    //slidesPerView: 'auto',
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
    slidesPerView: 1,
    breakpoints: {
      1280: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
  })

  new Swiper('.about-4lapy-mobile-home-phone-swiper', {
    slidesPerView: 1,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 1000,
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
  })
})
